/**
 * Headers and fetch helper for Hub staff edge functions (Supabase Auth JWT).
 */

import { supabase } from '../client'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? ''
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

/** POST to a Hub staff edge function using the current Supabase session. */
export async function callHubStaffEdgeFunction(
  name: string,
  body: Record<string, unknown> = {},
): Promise<Response> {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
  }

  const {
    data: { session },
  } = await supabase.auth.getSession()
  const token = session?.access_token
  if (!token) {
    throw new Error('Not authenticated')
  }

  const baseUrl = SUPABASE_URL.replace(/\/$/, '')
  return fetch(`${baseUrl}/functions/v1/${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  })
}
